// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"590be33a","405":"560a6f3b","591":"30d5fd51","787":"131abca7"}[chunkId] + ".chunk.js";
};